// Human-readable app version shown in the header under the user's name/role.
// BUMP THIS on every published change so it's easy to tell if the deployed
// frontend and backend are on the same version. Keep in sync with
// APP_VERSION in /app/backend/routers/misc.py (the /api/version endpoint).
export const APP_VERSION = "1.46.0";
